import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero7702 = () => {
  const handlePaymentClick = () => {
    // Ouvrir Stripe dans un popup centré
    const width = 600;
    const height = 800;
    const left = (window.screen.width / 2) - (width / 2);
    const top = (window.screen.height / 2) - (height / 2);
    
    window.open(
      'https://buy.stripe.com/3cI9AVbp97sQ2Q7fMJfAc03',
      'StripeCheckout',
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no`
    );
  };

  return (
    <section className="relative pt-16 sm:pt-20 lg:pt-24 pb-10 sm:pb-16 lg:pb-20 overflow-hidden bg-gradient-to-b from-[#0B1426] to-[#0a1935]">
      {/* Background decorative elements */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-10 sm:top-20 left-2 sm:left-10 w-40 sm:w-72 h-40 sm:h-72 bg-blue-500/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 sm:bottom-20 right-2 sm:right-10 w-48 sm:w-96 h-48 sm:h-96 bg-cyan-500/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left content */}
          <div className="text-left space-y-5 sm:space-y-6 lg:space-y-8">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white leading-tight">
              Crypto.com vous souhaite
              <br />
              <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                la bienvenue en Gestion Privée
              </span>
            </h1>

            <div className="space-y-3 sm:space-y-4">
              <p className="text-white/90 text-sm sm:text-base lg:text-lg leading-relaxed">
                Félicitations ! Votre profil a été reconnu comme éligible à notre service de gestion privée — un espace exclusif réservé aux investisseurs bénéficiant d'un accompagnement personnalisé et d'opportunités à haute valeur ajoutée.
              </p>
              <p className="text-white/90 text-sm sm:text-base lg:text-lg leading-relaxed">
                En intégrant notre gestion privée, vous accédez à un environnement privilégié, pensé pour la performance, la sécurité et la discrétion.
              </p>
              <p className="text-blue-400 text-base sm:text-lg lg:text-xl font-semibold">
                Vos avantages exclusifs :
              </p>
            </div>

            <div className="space-y-2 sm:space-y-3 lg:space-y-4">
              <div className="flex items-start gap-2 sm:gap-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-white/90 text-sm sm:text-base lg:text-lg">Accompagnement sur mesure : un analyste financier senior vous est dédié pour définir et suivre votre stratégie d'investissement.</p>
              </div>
              <div className="flex items-start gap-2 sm:gap-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-white/90 text-sm sm:text-base lg:text-lg">Produits d'épargne personnalisés : des solutions adaptées à votre profil d'investisseur et à vos objectifs financiers.</p>
              </div>
              <div className="flex items-start gap-2 sm:gap-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-white/90 text-sm sm:text-base lg:text-lg">Accès prioritaire aux opportunités du marché : ICOs, placements privés et nouveaux projets à fort potentiel.</p>
              </div>
              <div className="flex items-start gap-2 sm:gap-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-white/90 text-sm sm:text-base lg:text-lg">Outils de suivi avancés : tableaux de bord en temps réel, alertes marché et reporting sécurisé.</p>
              </div>
              <div className="flex items-start gap-2 sm:gap-3">
                <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                <p className="text-white/90 text-sm sm:text-base lg:text-lg">Avantages exclusifs membres : conditions préférentielles, accès anticipé aux nouveautés et support prioritaire.</p>
              </div>
            </div>

            <div className="flex flex-col gap-4 pt-2">
              <Button 
                onClick={handlePaymentClick}
                data-testid="cta-payment-button"
                className="bg-blue-500 hover:bg-blue-600 text-white px-4 sm:px-6 lg:px-8 py-4 sm:py-5 lg:py-6 text-sm sm:text-base lg:text-lg group w-full sm:w-auto"
              >
                <span className="text-center sm:text-left">Finalisez votre inscription en effectuant votre premier dépôt.</span>
                <ArrowRight className="ml-2 w-4 h-4 sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform flex-shrink-0" />
              </Button>
            </div>
          </div>

          {/* Right content - Phone mockup */}
          <div className="relative hidden lg:block">
            <div className="relative w-full max-w-md mx-auto">
              {/* Phone frame */}
              <div className="relative bg-gradient-to-br from-blue-900/50 to-purple-900/50 rounded-[3rem] p-3 shadow-2xl border border-blue-500/30">
                <div className="bg-[#0B1426] rounded-[2.5rem] p-6 overflow-hidden">
                  {/* Status bar */}
                  <div className="flex justify-between items-center mb-6">
                    <span className="text-white text-xs">9:41</span>
                    <div className="flex gap-1">
                      <div className="w-4 h-4 bg-white/20 rounded"></div>
                      <div className="w-4 h-4 bg-white/20 rounded"></div>
                      <div className="w-4 h-4 bg-white/20 rounded"></div>
                    </div>
                  </div>

                  {/* App content */}
                  <div className="space-y-4">
                    <div className="flex justify-between items-center mb-6">
                      <h3 className="text-white font-semibold text-xl">Portfolio</h3>
                      <div className="flex gap-2">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-lg text-sm font-medium">Buy</button>
                        <button className="px-4 py-2 bg-white/10 text-white rounded-lg text-sm font-medium">Sell</button>
                      </div>
                    </div>

                    <div className="bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-2xl p-6 border border-blue-500/30">
                      <div className="text-white/60 text-sm mb-1">Total Balance</div>
                      <div className="text-white text-3xl font-bold mb-1">$124,582.46</div>
                      <div className="text-green-400 text-sm">+$2,845.32 (2.35%)</div>
                    </div>

                    {/* Crypto list */}
                    <div className="space-y-3">
                      {['BTC', 'ETH', 'CRO'].map((crypto, idx) => (
                        <div key={crypto} className="flex items-center justify-between bg-white/5 rounded-xl p-4 hover:bg-white/10 transition-colors">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 bg-blue-500/30 rounded-full flex items-center justify-center">
                              <span className="text-white font-bold text-xs">{crypto}</span>
                            </div>
                            <div>
                              <div className="text-white font-medium">{crypto}</div>
                              <div className="text-white/60 text-xs">0.{Math.floor(Math.random() * 9000) + 1000}</div>
                            </div>
                          </div>
                          <div className="text-right">
                            <div className="text-white font-medium">${(Math.random() * 50000 + 1000).toFixed(2)}</div>
                            <div className={`text-xs ${idx % 2 === 0 ? 'text-green-400' : 'text-red-400'}`}>
                              {idx % 2 === 0 ? '+' : '-'}{(Math.random() * 5).toFixed(2)}%
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Decorative glow */}
              <div className="absolute inset-0 bg-blue-500/20 blur-3xl -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero7702;
